module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"GN Informatica di Nespoli Giuseppe","short_name":"GN Informatica","start_url":"/","description":"GN Informatica di Nespoli Giuseppe. Servizi informatici aziendali, supporto tecnico, strumenti per il cloud e per la collaborazione e molto altro","background_color":"#FB7600","lang":"it","icon_options":{"purpose":"maskable"},"theme_color":"#FB7600","display":"browser","icon":"./src/assets/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1000,"linkImagesToOriginal":true,"sizeByPixelDensity":true,"quality":70,"withWebp":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://gnsoftware.it/"},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"yellow","showSpinner":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
